module.exports = __webpack_public_path__ + "static/media/social3.3a1840c2.svg";